export class CaptchaConfigurationRequest {
  domain: string;
  preferredCaptcha?: string = undefined;

  constructor(domain: string, preferredCaptcha: string = '') {
    this.domain = domain;
    preferredCaptcha && (this.preferredCaptcha = preferredCaptcha);
  }
}
